<div class="product-brief-container">

    <div class="closebtn" (click)="closeDialog()">
        <span class="material-icons">
            close
        </span>
    </div>

    <!-- <div class="img featured_cart">
        <img [src]="productDetails?.logo_link" alt="">
    </div> -->
    <div class="product-info-cart">
        <h4>Course Highlights</h4>
        <ul>
            <li *ngIf="productDetails?.feature_1">
                <div class="img">
                    <img src="https://media.iquanta.in/ui_images/new-dashboard/icon-videos.svg" alt="" loading="lazy">
                </div>
                <span>{{productDetails?.feature_1}}</span>
            </li>
            <li *ngIf="productDetails?.feature_2">
                <div class="img"><img src="https://media.iquanta.in/ui_images/new-dashboard/icon-sectional.svg" alt="" loading="lazy"></div>
                <span>{{productDetails?.feature_2}}</span>
            </li>
            <li *ngIf="productDetails?.feature_3">
                <div class="img"><img src="https://media.iquanta.in/ui_images/new-dashboard/icon-iim-calls.svg" alt="" loading="lazy"></div>
                <span>{{productDetails?.feature_3}}</span>
            </li>
            <li *ngIf="productDetails?.feature_4">
                <div class="img"><img src="https://media.iquanta.in/ui_images/new-dashboard/icon-scored.svg" alt="" loading="lazy"> </div>
                <span>{{productDetails?.feature_4}}</span>
            </li>
        </ul>
    </div>
    <div class="product-addons">
        <h4>Extra Addons</h4>
        <ul>
            <li *ngFor="let addon of productDetails?.addons;let i = index">
                <div class="chekboxes">
                    <mat-checkbox [checked]="addonList.includes(addon)"  (change)="addonCourse($event, addon)">
                        {{addon.course_name}}   
                        <svg  (click)="displayTooltip(i)"  id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        viewBox="0 0 16 16" fill="none">
                        <g clip-path="url(#clip0_108_983)">
                            <path
                                d="M7.99967 15.0328C7.7246 15.0334 7.45295 14.9718 7.20508 14.8525C6.9572 14.7333 6.73952 14.5595 6.56834 14.3442L5.34301 12.8108C5.26506 12.7131 5.16607 12.6343 5.05341 12.5801C4.94076 12.526 4.81733 12.498 4.69234 12.4982H2.66634C2.18062 12.4976 1.71491 12.3046 1.37127 11.9613C1.02762 11.618 0.834066 11.1526 0.833008 10.6668V2.66683C0.833537 2.18076 1.02686 1.71475 1.37056 1.37105C1.71427 1.02735 2.18027 0.834025 2.66634 0.833496H13.333C13.8191 0.834025 14.2851 1.02735 14.6288 1.37105C14.9725 1.71475 15.1658 2.18076 15.1663 2.66683V10.6668C15.1658 11.1529 14.9725 11.6189 14.6288 11.9626C14.2851 12.3063 13.8191 12.4996 13.333 12.5002H11.307C11.1819 12.5 11.0584 12.528 10.9456 12.5821C10.8329 12.6362 10.7338 12.7151 10.6557 12.8128L9.43101 14.3462C9.25956 14.561 9.04178 14.7344 8.79393 14.8533C8.54608 14.9722 8.27457 15.0336 7.99967 15.0328ZM2.66634 1.8335C2.44544 1.83385 2.23368 1.92176 2.07747 2.07796C1.92127 2.23417 1.83336 2.44592 1.83301 2.66683V10.6668C1.83336 10.8877 1.92127 11.0995 2.07747 11.2557C2.23368 11.4119 2.44544 11.4998 2.66634 11.5002H4.69234C4.96734 11.4996 5.23893 11.5611 5.48678 11.6803C5.73464 11.7994 5.95236 11.973 6.12367 12.1882L7.34901 13.7215C7.42968 13.815 7.52956 13.89 7.64184 13.9415C7.75413 13.9929 7.87617 14.0195 7.99967 14.0195C8.12317 14.0195 8.24522 13.9929 8.35751 13.9415C8.46979 13.89 8.56967 13.815 8.65034 13.7215L9.87501 12.1882C10.0466 11.9731 10.2644 11.7996 10.5124 11.6805C10.7603 11.5613 11.0319 11.4997 11.307 11.5002H13.333C13.5539 11.4998 13.7657 11.4119 13.9219 11.2557C14.0781 11.0995 14.166 10.8877 14.1663 10.6668V2.66683C14.166 2.44592 14.0781 2.23417 13.9219 2.07796C13.7657 1.92176 13.5539 1.83385 13.333 1.8335H2.66634Z"
                                fill="#FCBF29" />
                            <path
                                d="M8 7.83333C7.86739 7.83333 7.74022 7.78065 7.64645 7.68689C7.55268 7.59312 7.5 7.46594 7.5 7.33333V4C7.5 3.86739 7.55268 3.74021 7.64645 3.64645C7.74022 3.55268 7.86739 3.5 8 3.5C8.13261 3.5 8.25978 3.55268 8.35355 3.64645C8.44732 3.74021 8.5 3.86739 8.5 4V7.33333C8.5 7.46594 8.44732 7.59312 8.35355 7.68689C8.25978 7.78065 8.13261 7.83333 8 7.83333Z"
                                fill="#FCBF29" />
                            <path
                                d="M7.99935 10.6667C8.45959 10.6667 8.83268 10.2936 8.83268 9.83333C8.83268 9.3731 8.45959 9 7.99935 9C7.53911 9 7.16602 9.3731 7.16602 9.83333C7.16602 10.2936 7.53911 10.6667 7.99935 10.6667Z"
                                fill="#FCBF29" />
                        </g>
                        <defs>
                            <clipPath id="clip0_108_983">
                                <rect width="16" height="16" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                    </mat-checkbox>

                </div>
               
                <div  class="tool_tip" (click)="gotolink1()" 
                *ngIf="showTooltipFlag1 && toolTipObj.id == addon.id">
                    {{addon.description}}
                </div>
                <span>{{addon.special_price|currency}}</span>
            </li>
        </ul>
    </div>
    <div class="coupone_wrapper">
        <div class="input-group" *ngIf="!couponCode && !referralCode">
            <input (click)="couponOpen()" type="text" class="form-control" placeholder="Apply Coupon">
            <div class="input-group-append">
                <button class="btn" (click)="couponOpen()" type="button">Apply</button>
            </div>
        </div>
        <div class="input-group" *ngIf="couponCode || referralCode">
            <input readonly type="text" class="form-control" placeholder="{{couponCode ? couponCode : referralCode}}">
            <div class="input-group-append">
                <button class="btn" (click)="removeCoupon()" type="button">Remove</button>
            </div>
        </div>
    </div>

   
    <div class="applied-text" *ngIf="couponCode || referralCode">
        <h6>
            You have saved {{discountAmount|currency}}</h6>
    </div>
   
    <div class="cart-actions">

        <ng-container *ngIf="displayShareButtons">
            <div class="share-icons position-absolute">
                <share-buttons theme="circles-dark"
                    [include]="[ 'facebook', 'pinterest',  'twitter',  'whatsapp']"
                    [showIcon]="true" [showText]="false" (opened)="dialogClose($event)"
                    url="{{dom.URL}}" [description]="'Hey, Please check this Course'">
                </share-buttons>
            </div>
        </ng-container>

        <div class="top-butns d-flex justify-content-between align-items-center">

            <div class="priceCard">
                <span><del>{{productDetails?.actual_price|currency}}</del></span>
                <h3>{{totalAmount|currency}}</h3>
            </div>

            <div class="d-flex cart_actions">
                <button mat-button (click)="download()" matTooltip="Download Brochure">
                    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="28"
                        viewBox="0 0 31 28" fill="none">
                        <path
                            d="M6.35484 10.0781L15.5 19.2501M15.5 19.2501L24.6452 10.0781M15.5 19.2501V0.0527344M29 19.2501V24.6098C29 25.5009 28.2037 26.231 27.2315 26.231H3.76851C2.79635 26.231 2 25.5009 2 24.6098V19.2501"
                            stroke="white" stroke-width="2.5" stroke-miterlimit="10" />
                    </svg>
                </button>

                <button class="wishlist" mat-button matTooltip="Add to WishList"
                    (click)="addToWishlist()" *ngIf="!wishList.includes(productId)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="29"
                        viewBox="0 0 33 29" fill="none">
                        <path
                            d="M16.5 27.2446C16.5 27.2446 2 19.2355 2 9.51024C2.0003 7.79135 2.60415 6.1256 3.70889 4.79622C4.81363 3.46683 6.35108 2.55586 8.05982 2.21819C9.76857 1.88052 11.5432 2.13699 13.0818 2.944C14.6205 3.75101 15.8284 5.05874 16.5 6.64486C17.1716 5.05874 18.3794 3.75102 19.9181 2.94401C21.4568 2.13699 23.2314 1.88052 24.9402 2.21819C26.6489 2.55586 28.1864 3.46683 29.2911 4.79621C30.3959 6.1256 30.9997 7.79135 31 9.51024C31 19.2355 16.5 27.2446 16.5 27.2446Z"
                            stroke="white" stroke-width="2.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </button>

                <button mat-button matTooltip="Remove from WishList" (click)="removeWishlist()"
                    *ngIf="wishList.includes(productId)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="29" viewBox="0 0 33 29" fill="none">
                        <path d="M16.5 27.2446C16.5 27.2446 2 19.2355 2 9.51024C2.0003 7.79135 2.60415 6.1256 3.70889 4.79622C4.81363 3.46683 6.35108 2.55586 8.05982 2.21819C9.76857 1.88052 11.5432 2.13699 13.0818 2.944C14.6205 3.75101 15.8284 5.05874 16.5 6.64486C17.1716 5.05874 18.3794 3.75102 19.9181 2.94401C21.4568 2.13699 23.2314 1.88052 24.9402 2.21819C26.6489 2.55586 28.1864 3.46683 29.2911 4.79621C30.3959 6.1256 30.9997 7.79135 31 9.51024C31 19.2355 16.5 27.2446 16.5 27.2446Z" fill="#D9D9D9" stroke="#FAB269" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10 2.5L4 4L1.5 9L3 16L15 26.5L18.5 26L27.5 17.5L31 10.5L28.5 4L22.5 2.5L20 4L16 7L14 4L10 2.5Z" fill="#FAB269" stroke="#FAB269"/>
                        </svg>
                </button>

                <button mat-button matTooltip="Share with Friends" (click)="shareCode()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33"
                        viewBox="0 0 32 33" fill="none">
                        <path
                            d="M8.78298 25.0821C3.94894 25.0821 0 21.1145 0 16.1893C0 11.264 3.94894 7.29647 8.78298 7.29647C13.617 7.29647 17.566 11.264 17.566 16.1893C17.566 21.1145 13.617 25.0821 8.78298 25.0821ZM8.78298 9.96432C5.37872 9.96432 2.65532 12.769 2.65532 16.1893C2.65532 19.6096 5.37872 22.4143 8.78298 22.4143C12.1872 22.4143 14.9106 19.6096 14.9106 16.1893C14.9106 12.769 12.1872 9.96432 8.78298 9.96432ZM26.2128 11.8113C23.0128 11.8113 20.4255 9.21185 20.4255 5.92835C20.4255 2.64485 23.0128 0.0454102 26.2128 0.0454102C29.4128 0.0454102 32 2.64485 32 5.92835C32 9.21185 29.4128 11.8113 26.2128 11.8113ZM26.2128 2.78166C24.5106 2.78166 23.0809 4.21819 23.0809 5.99675C23.0809 7.77532 24.5106 9.21185 26.2128 9.21185C27.9149 9.21185 29.3447 7.77532 29.3447 5.99675C29.3447 4.21819 27.9149 2.78166 26.2128 2.78166ZM26.2128 32.2648C23.0128 32.2648 20.4255 29.6653 20.4255 26.3818C20.4255 23.0983 23.0128 20.4989 26.2128 20.4989C29.4128 20.4989 32 23.0983 32 26.3818C32 29.6653 29.4128 32.2648 26.2128 32.2648ZM26.2128 23.2351C24.5106 23.2351 23.0809 24.6717 23.0809 26.4502C23.0809 28.2288 24.5106 29.6653 26.2128 29.6653C27.9149 29.6653 29.3447 28.2288 29.3447 26.4502C29.3447 24.6717 27.9149 23.2351 26.2128 23.2351Z"
                            fill="#FDFDFD" />
                        <path
                            d="M15.251 13.7267C14.8425 13.7267 14.3659 13.5214 14.0936 13.111C13.6851 12.4953 13.8893 11.6745 14.5021 11.264L20.9702 7.09125C21.583 6.68082 22.4 6.88603 22.8085 7.50169C23.217 8.11735 23.0127 8.93822 22.4 9.34866L15.9319 13.5214C15.7276 13.6583 15.4553 13.7267 15.251 13.7267ZM21.7191 25.903C21.5149 25.903 21.2425 25.8346 21.0383 25.6978L14.5702 21.7986C13.9574 21.3882 13.7532 20.5673 14.0936 19.9516C14.5021 19.336 15.3191 19.1308 15.9319 19.4728L22.4 23.3719C23.0127 23.7824 23.217 24.6033 22.8766 25.2189C22.6042 25.6978 22.1957 25.903 21.7191 25.903Z"
                            fill="#FDFDFD" />
                    </svg>
                </button>
            </div>
          
        </div>
        <div class="card_footer d-flex justify-content-between">
        <button class="buy_now neonShadow button-wiggle" mat-raised-button
            (click)="buynow()">Proceed Now</button>
            <button class="buy_now1 " (click)="joinwhatsappEnquiry('https://api.whatsapp.com/send/?phone=918130900243')" mat-button>
                <span class="mr-1"><i class="bi bi-whatsapp"></i></span> Enquire Now</button>
         </div>
                <div class="w-100 emi-text text-center">
        
                <p><span><i class="bi bi-arrow-up-right"></i></span> Looking for <strong>EMI</strong> Options? <a (click)="emioption()">Enquire Now!</a></p>
               </div>
    </div>
    <!-- <div class="price-coupom d-flex justify-content-between mb-4" *ngIf="couponCode || referralCode">

        <div class="couponCode">
            <h6 *ngIf="couponCode"><img src="https://media.iquanta.in/ui_images/new-home/couponcode.png" alt=""> {{couponCode}}</h6>
            <h6 *ngIf="referralCode"><img src="https://media.iquanta.in/ui_images/new-home/couponcode.png" alt=""> {{referralCode}}</h6>

        </div>
        <div class="priceCard d-flex">
            <span *ngIf="discountAmount">{{discountAmount|currency}}</span>
            <span *ngIf="referralAmount">{{referralAmount|currency}}</span>
            <div class="removeicon" (click)="removeCoupon()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-x-circle" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path
                        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
            </div>

        </div>
    </div>
    <div class="bttom-footer">
        <div class="price-coupom d-flex justify-content-between">
            <div class="couponCode">
                <h6 *ngIf="!couponCode && !referralCode" (click)="couponOpen()"><img src="https://media.iquanta.in/ui_images/new-home/couponcode.png" alt=""> Apply Coupon
                </h6>
            </div>
    
            <div class="priceCard text-end">
                <span><del>{{productDetails?.actual_price|currency}}</del></span>
                <h3>{{totalAmount|currency}}</h3>
            </div>
        </div>
        <div class="cart-actions">
            <button class="buy_now" mat-button (click)="buynow()">Buy Now</button>
            <button mat-button (click)="download()" matTooltip="Download Brochure">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download"
                    viewBox="0 0 16 16">
                    <path
                        d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                    <path
                        d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                </svg>
            </button>
            <button mat-button matTooltip="Add to WishList" (click)="addToWishlist()" *ngIf="!wishList.includes(productId)">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-heart"
                    viewBox="0 0 16 16">
                    <path
                        d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z" />
                </svg>
            </button>
            <button mat-button matTooltip="Remove from WishList" (click)="removeWishlist()"
                *ngIf="wishList.includes(productId)">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-heart-fill"
                    viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                        d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z" />
                </svg>
            </button>
        </div>
    </div> -->


</div>